{
  "#WEIGHT_REPORT":  {
    "TITLE": "Gewichtsmeldung"
  },
  "#FATTENER_INFO":  {
    "SECTION_TITLE": "Informationen"
  },
  "#REPORT_FORM": {
    "SECTION_HEADERS": {
      "STALL": "Stallauswahl",
      "FORM": "Gewichtsmeldung für "
    },
    "CONTROLS": {
      "STALL": "Ausgewählter Stall",
      "QUANTITY": "Anzahl",
      "WEIGHT": "Durchschnittsgewicht in kg",
      "WEIGHT_LOSS": "Ausfall in %",
      "ADDITIONAL_INFO": "Anmerkungen",
      "SET_DATE": "Einstellungsdatum",
      "DAY": "Tage seit der Einstellung",
      "SALMONELLAE": {
        "LABEL": "Salmonellen",
        "YES": "Ja",
        "NO": "Nein"
      },
      "SUBMIT": "Gewicht melden"
    },
    "PLACEHOLDER": {
      "TITLE": "Kein Stall ausgewählt",
      "SECONDARY_TEXT": "Bitte wählen Sie einen Stall aus um eine Gewichtsmeldung vorzunehmen..."
    }
  },
  "#MESSAGES": {
    "ADD_SUCCESS_TITLE": "Erfolgreich",
    "ADD_SUCCESS_MESSAGE": "Die Gewichtsmeldung wurde erfasst",
    "ADD_FAILURE_TITLE": "Fehler",
    "ADD_FAILURE_MESSAGE": "Die Gewichtsmeldung konnte nicht erfasst werden",
    "LOAD_TEMPLATE_FAILURE_TITLE": "Fehler",
    "LOAD_TEMPLATE_FAILURE_MESSAGE": "Es konnte keine Daten vorbefüllt werden"
  }
}
